import { render, staticRenderFns } from "./ComplaintsReportData.vue?vue&type=template&id=60db429c"
import script from "./ComplaintsReportData.vue?vue&type=script&lang=js"
export * from "./ComplaintsReportData.vue?vue&type=script&lang=js"
import style0 from "./ComplaintsReportData.vue?vue&type=style&index=0&id=60db429c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports